export default __webpack_public_path__ + "static/media/overview.6ee178fe.png";